var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarket({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons / \xD0\x93\xD0\xB8\xD0\xBF\xD0\xB5\xD1\x80\xD0\xBC\xD0\xB0\xD1\x80\xD0\xBA\xD0\xB5\xD1\x82"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M4.1665 4.1665H6.88768C7.40022 4.1665 7.65649 4.1665 7.86272 4.26075C8.04446 4.34381 8.19847 4.47739 8.3064 4.64556C8.42887 4.83639 8.46511 5.09009 8.53759 5.59747L9.52365 12.4998M9.52365 12.4998L11.7151 28.6069C11.9932 30.6509 12.1322 31.6729 12.6209 32.4422C13.0515 33.1201 13.6688 33.6591 14.3985 33.9944C15.2266 34.3748 16.2581 34.3748 18.3209 34.3748H36.1498C38.1135 34.3748 39.0953 34.3748 39.8977 34.0215C40.6051 33.71 41.212 33.2078 41.6504 32.5711C42.1476 31.849 42.3313 30.8846 42.6987 28.9556L45.4563 14.4784C45.5856 13.7994 45.6503 13.46 45.5566 13.1946C45.4744 12.9619 45.3122 12.7658 45.0989 12.6415C44.8558 12.4998 44.5102 12.4998 43.8191 12.4998H9.52365ZM20.8332 43.7498C20.8332 44.9004 19.9004 45.8332 18.7498 45.8332C17.5992 45.8332 16.6665 44.9004 16.6665 43.7498C16.6665 42.5992 17.5992 41.6665 18.7498 41.6665C19.9004 41.6665 20.8332 42.5992 20.8332 43.7498ZM37.4998 43.7498C37.4998 44.9004 36.5671 45.8332 35.4165 45.8332C34.2659 45.8332 33.3332 44.9004 33.3332 43.7498C33.3332 42.5992 34.2659 41.6665 35.4165 41.6665C36.5671 41.6665 37.4998 42.5992 37.4998 43.7498Z",
    stroke: "#956446",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarket);
export default __webpack_public_path__ + "static/media/market.3adeac11d45deec4ac5e31d7612a92d1.svg";
export { ForwardRef as ReactComponent };